module.exports = "<svg height=\"19\" width=\"14\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 19\"><path fill-rule=\"evenodd\" d=\"M11.85 11.8V19l-4.87-3.57L2.14 19v-7.22A6.72 6.72 0 0 1 0 6.86C0 3.07 3.13 0 7 0s7 3.07 7 6.86c0 1.94-.83 3.69-2.15 4.94zM8.11 5.18L6.96 2.09 5.88 5.18l-3.55.17 2.99 1.74-1.22 3.54 2.88-2.17 2.84 2.17-1.3-3.64 3.06-1.64-3.47-.17z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/fair.svg
// module id = 880
// module chunks = 0